<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("Online Booking Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="fromDate"
                  @click="fromDate = ''"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="toDate"
                  @click="toDate = ''"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">{{
                  $t("todate")
                }}</label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <b-form-input
                v-debounce:500="getOnlineBookingsReport"
                v-model="searchValue"
                placeholder="Search Name/Mobile/Email/BookingCode"
              />
              <label :class="searchValue ? 'active' : ''">{{ "Search" }}</label>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getOnlineBookingsReport({isPdf:'N',isExcel :'N'})"
            >
              {{ $t("fetch") }}
             
            </button>
          </div>
        </div>
      </div>
      <div
        v-if="onlineSalesRecords.length > 0"
        class="col-lg-6 col-xl-3 align-self-center mb-3 d-flex align-items-center justify-content-end ml-auto"
      >
        <div class="mx-1">{{ $t("download") }} as:</div>
        <!-- s -->
        <a
          target="_blank"
          @click="getOnlineBookingsReport({isPdf:'Y',isExcel :'N'})"
          title="Download as Pdf"
          download
        >
          <img
            class="mx-1"
            src="@/assets/img/icons/pdf.svg"
            height="25"
            width="25"
          />
        </a>
        <a
          target="_blank"
          @click="getOnlineBookingsReport({isPdf:'N',isExcel :'Y'})"
          title="Download as Excel"
          download
        >
          <img
            class="mx-1"
            src="@/assets/img/icons/excel.svg"
            height="25"
            width="25"
          />
        </a>
      </div>
      <div
        style="overflow-x: scroll; width: auto !important"
        v-if="onlineSalesRecords.length > 0"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <tr class="bg-lightgrey font-weight-bold">
            <th>Cinema</th>
            <th>Business Date</th>
            <th>Transaction Date & Time</th>
            <th>Transaction Id</th>
            <th>Reservation Id</th>
            <th>Invoice No.</th>
            <th>Source</th>
            <th>Show Date</th>
            <th>Show Time</th>
            <th>Movie/Item</th>
            <th>Seats</th>
            <!-- <th>Digital Order Id</th> -->
            <th>Customer Name</th>
            <th>Email</th>
            <th>Mobile</th>
          </tr>
          <tbody>
            <template
              v-for="(
                onlineBookingsData, onlineBookingsIndex
              ) in onlineSalesRecords"
            >
              <tr
                v-if="!onlineBookingsData.hasOwnProperty('fst_id')"
                :key="onlineBookingsIndex"
              >
                <td class="text-left">{{ onlineBookingsData.cine_name }}</td>
                <td class="text-left">
                  {{
                    moment(onlineBookingsData.ss_start_date).format(
                      "YYYY-MM-DD"
                    )
                  }}
                </td>
                <td class="text-left">
                  {{
                    onlineBookingsData.created_at
                  }}
                </td>
                <td class="text-left">{{ onlineBookingsData.invoice_no }}</td>
                <td class="text-left">{{onlineBookingsData.reservation_id}}</td>
                <td class="text-left">T{{ onlineBookingsData.t_id }}</td>
                <td class="text-left">{{ onlineBookingsData.bs_source }}</td>
                <td class="text-left">{{ onlineBookingsData.show_date }}</td>
                <td class="text-left">{{ onlineBookingsData.show_time }}</td>
                <!-- <td class="text-right">-</td> -->
                <td class="text-left">{{ onlineBookingsData.movie_name }}</td>
                <td class="text-left">{{ onlineBookingsData.seat_name || '-' }}</td>
                
                <td class="text-left">
                  {{
                    onlineBookingsData.customer_name ||
                    onlineBookingsData.guest_name ||
                    "-"
                  }}
                </td>
                <td class="text-left">
                  {{
                    onlineBookingsData.cust_email ||
                    onlineBookingsData.guest_email ||
                    "-"
                  }}
                </td>
                <td class="text-left">
                  {{
                    onlineBookingsData.customer_mobile ||
                    onlineBookingsData.guest_mobile ||
                    "-"
                  }}
                </td>
              </tr>
              <tr
                v-if="onlineBookingsData.hasOwnProperty('fst_id')"
                :key="onlineBookingsIndex + 'fnbSalesData'"
              >
                <td class="text-left">{{ onlineBookingsData.cine_name }}</td>
                <td class="text-left">
                  {{ onlineBookingsData.ss_start_date }}
                </td>
                <td class="text-left">{{ onlineBookingsData.created_at }}</td>
                <td class="text-left">{{ onlineBookingsData.invoice_no }}</td>
                <td class="text-left">F{{ onlineBookingsData.fst_id }}</td>
                <td class="text-left">{{ onlineBookingsData.bs_source }}</td>
                <td class="text-left">{{ onlineBookingsData.show_date }}</td>
                <td class="text-left">{{ onlineBookingsData.show_time }}</td>
                <td class="text-left">
                  {{ onlineBookingsData.fst_item_name }}
                </td>
                <td class="text-left">-</td>
                <!-- <td class="text-left">-</td> -->
                <td class="text-left">
                  {{
                    onlineBookingsData.customer_name ||
                    onlineBookingsData.guest_name ||
                    "-"
                  }}
                </td>
                <td class="text-left">
                  {{
                    onlineBookingsData.cust_email ||
                    onlineBookingsData.guest_email ||
                    "-"
                  }}
                </td>
                <td class="text-left">
                  {{
                    onlineBookingsData.customer_mobile ||
                    onlineBookingsData.guest_mobile ||
                    "-"
                  }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="swc-report" v-if="onlineSalesRecords.length == 0">
        <table class="swc-report-table">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Cinema</th>
            <th>Business Date</th>
            <th>Transaction Date & Time</th>
            <th>Transaction Id</th>
            <th>Reservation Id</th>
            <th>Invoice No.</th>
            <th>Source</th>
            <th>Show Date</th>
            <th>Show Time</th>
            <th>Movie/Item</th>
            <th>Seats</th>
            <!-- <th>Digital Order Id</th> -->
            <th>Customer Name</th>
            <th>Email</th>
            <th>Mobile</th>
          </thead>
          <tbody>
            <tr>
              <td colspan="13">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
        selectedCinemaAddress:"",
      },
      fromDate: moment().toDate(),
      toDate: new Date(),
      onlineSalesRecords: [],
      onlineFnbSalesRecords: [],
      searchValue: "",
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    if (CinemaObj) {
      this.onSelectCinema(CinemaObj);
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(CinemaObj);
      }
    },
  },
  mounted() {},
  methods: {
    onChangeDate: function(e, type){
      if(type == 'from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, { sheet: "OnlineBookingReport" });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(wb, fn || "OnlineBookingReport." + (type || "xlsx"));
    },
    excelDownload() {
      let temp_data = [];
      this.houseKeepingRecords.map((x, index) => {
        let obj = { ...x, index: index + 1 };
        temp_data.push(obj);
      });
      let data = [
        {
          sheet: "House Keeping Report",
          columns: [
            {
              value: (row) => moment(row.schedule_date).format("YYYY-MM-DD"),
              label: "Date",
            },
            {
              value: "cinema_name",
              label: "Branch",
            },
            {
              value: "index",
              label: "Show No.",
            },
            {
              value: "screen_name",
              label: "Screen Name",
            },
            {
              value: "movie_name",
              label: "Movie Name",
            },
            {
              value: "start_time",
              label: "Start Time",
            },
            {
              value: "end_time",
              label: "End Time",
            },
            {
              value: (row) =>
                row.screen_total_seats ? row.screen_total_seats : "-",
              label: "Capacity",
            },
            {
              value: (row) =>
                row.booked_seats && row.screen_total_seats
                  ? +parseFloat(
                      parseFloat(row.booked_seats / row.screen_total_seats) *
                        100
                    ).toFixed(this.MIN_FRACTION_DIGITS)
                  : "-",
              label: "Occupancy",
            },
          ],
          content: temp_data,
        },
      ];
      let settings = {
        fileName: `HouseKeepingReport_${
          this.dropDown.selectedCinemaName
        }_${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.dropDown.selectedCinemaAddress = event.cine_address;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getOnlineBookingsReport({isPdf="N",isExcel = "N"}) {
      this.onlineSalesRecords = [];
      this.onlineFnbSalesRecords = [];
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinema.cine_name,
        cinema_address: this.dropDown.selectedCinemaAddress,

        fromDate: this.fromDate
          ? moment(this.fromDate).format("YYYY-MM-DD")
          : "",
        toDate: this.toDate ? moment(this.toDate).format("YYYY-MM-DD") : "",
        search_value: this.searchValue,
        isExcel,
        isPdf
      };
      ReportsService.GetOnlineBookingsReport(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.onlineSalesRecords = [...data.Records];
            this.onlineFnbSalesRecords = [...data.fnbSalesRecords];
            this.$toasted.show(data.message);
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}
.swc-report-table td {
  white-space: nowrap;
}
.swc-report-table th {
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/onlineSalesReport.vue